/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * 
 * @export
 * @interface GetAutoMediaListMediaOutletsRequest
 */
export interface GetAutoMediaListMediaOutletsRequest {
    /**
     * メディアリストのIDリスト
     * @type {Array<number>}
     * @memberof GetAutoMediaListMediaOutletsRequest
     */
    mediaListIds?: Array<number>;
    /**
     * メディア種別のIDリスト
     * @type {Array<number>}
     * @memberof GetAutoMediaListMediaOutletsRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 発行部数/PVのリスト
     * @type {Array<MediaReach>}
     * @memberof GetAutoMediaListMediaOutletsRequest
     */
    reaches: Array<MediaReach>;
    /**
     * 検索キーワードリスト
     * @type {Array<string>}
     * @memberof GetAutoMediaListMediaOutletsRequest
     */
    searchKeywords: Array<string>;
    /**
     * ソート対象のフィールド名。値を指定しない場合、デフォルトのソート順はメディア種類IDの昇順、メディアIDの昇順になる。複数選択不可。
     * @type {string}
     * @memberof GetAutoMediaListMediaOutletsRequest
     */
    sortField: GetAutoMediaListMediaOutletsRequestSortFieldEnum;
}

/**
* @export
* @enum {string}
*/
export enum GetAutoMediaListMediaOutletsRequestSortFieldEnum {
    MediaType = 'media_type',
    Aiueo = 'aiueo'
}

export function GetAutoMediaListMediaOutletsRequestFromJSON(json: any): GetAutoMediaListMediaOutletsRequest {
    return GetAutoMediaListMediaOutletsRequestFromJSONTyped(json, false);
}

export function GetAutoMediaListMediaOutletsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoMediaListMediaOutletsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': !exists(json, 'media_list_ids') ? undefined : json['media_list_ids'],
        'mediaTypeIds': json['media_type_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
        'searchKeywords': json['search_keywords'],
        'sortField': json['sort_field'],
    };
}

export function GetAutoMediaListMediaOutletsRequestToJSON(value?: GetAutoMediaListMediaOutletsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
        'media_type_ids': value.mediaTypeIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
        'search_keywords': value.searchKeywords,
        'sort_field': value.sortField,
    };
}

